export default class {
    constructor ($location, $translate, $rootScope, $locale, moment, lodash, TokenService) {
        this.$location = $location;
        this.$translate = $translate;
        this.$locale = $locale;
        this.lodash = lodash;
        this.TokenService = TokenService;
        this.moment = moment;

        $rootScope.$on('$translateChangeSuccess', (event, data) => {
            this.changeCalendarLanguage(data.language);
        });
    }

    /**
     * This function detects and changes the language.
     * All language switches should be done through this function
     * Language to switch to is found in the following order
     * 1. If forceLanguage param is given
     * 2. If url contains lang parameter
     * 3. If token is present, language is taken from getActiveLanguage()
     * 4. If all else fails, language is taken from APP_DEFAULT_LANGUAGE config
     * @param {string} [forceLanguage]
     */
    changeLanguage (forceLanguage) {
        // if forceLanguage is given, use it, else get url lang parameter
        let lang = angular.isString(forceLanguage) ? forceLanguage : this.$location.search().lang;
        if (!lang) {
            // secondly check if Token is present
            if (this.TokenService.hasToken()) {
                lang = this.TokenService.getActiveLanguage(true);
            }
            else {
                lang = SEED_CORE.ENV.APP_DEFAULT_LANGUAGE;
            }
        }
        // Change moment locale
        this.moment.locale(lang);
        // return $translate.use() promise that is resolved once all angular translations are loaded
        return this.$translate.use(lang);
    }

    /**
     * This function changes $locale languages depending on user language
     * TODO: this is a hack and needs to be solved properly via $translatePartialLoader or smh
     * more info @ https://angular-translate.github.io/docs/#/guide/12_asynchronous-loading#asynchronous-loading_using-partialloader
     * @param language short code of language to be used for translations, currently support et, en
     */
    changeCalendarLanguage (language) {
        const translations = {
            et: {
                id: 'et',
                DATETIME_FORMATS: {
                    AMPMS: ['enne keskpäeva', 'pärast keskpäeva'],
                    DAY: ['Pühapäev', 'Esmaspäev', 'Teisipäev', 'Kolmapäev', 'Neljapäev', 'Reede', 'Laupäev'],
                    MONTH: [
                        'Jaanuar',
                        'Veebruar',
                        'Märts',
                        'Aprill',
                        'Mai',
                        'Juuni',
                        'Juuli',
                        'August',
                        'September',
                        'Oktoober',
                        'November',
                        'Detsember'
                    ],
                    SHORTDAY: ['P', 'E', 'T', 'K', 'N', 'R', 'L'],
                    SHORTMONTH: ['Jaan', 'Veebr', 'Märts', 'Apr', 'Mai', 'Juuni', 'Juuli', 'Aug', 'Sept', 'Okt', 'Nov', 'Dets'],
                    fullDate: 'EEEE, d. MMMM y',
                    longDate: 'd. MMMM y',
                    medium: 'dd.MM.yyyy H:mm.ss',
                    mediumDate: 'dd.MM.yyyy',
                    mediumTime: 'H:mm.ss',
                    short: 'dd.MM.yy H:mm',
                    shortDate: 'dd.MM.yy',
                    shortTime: 'H:mm'
                }
            },
            en: {
                id: 'en-us',
                DATETIME_FORMATS: {
                    AMPMS: ['AM', 'PM'],
                    DAY: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                    MONTH: [
                        'January',
                        'February',
                        'March',
                        'April',
                        'May',
                        'June',
                        'July',
                        'August',
                        'September',
                        'October',
                        'November',
                        'December'
                    ],
                    SHORTDAY: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                    SHORTMONTH: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                    fullDate: 'EEEE, MMMM d, y',
                    longDate: 'MMMM d, y',
                    medium: 'MMM d, y h:mm:ss a',
                    mediumDate: 'MMM d, y',
                    mediumTime: 'h:mm:ss a',
                    short: 'M/d/yy h:mm a',
                    shortDate: 'M/d/yy',
                    shortTime: 'h:mm a'
                }
            },
            lt: {
                id: 'lt',
                DATETIME_FORMATS: {
                    AMPMS: ['priešpiet', 'popiet'],
                    DAY: ['sekmadienis', 'pirmadienis', 'antradienis', 'trečiadienis',
                        'ketvirtadienis', 'penktadienis', 'šeštadienis'],
                    MONTH: [
                        'sausis',
                        'vasaris',
                        'kovas',
                        'balandis',
                        'gegužė',
                        'birželis',
                        'liepa',
                        'rugpjūtis',
                        'rugsėjis',
                        'spalis',
                        'lapkritis',
                        'gruodis'
                    ],
                    SHORTDAY: ['Sk', 'Pr', 'An', 'Tr', 'Kt', 'Pn', 'Št'],
                    SHORTMONTH: ['saus.', 'vas.', 'kov.', 'bal.', 'geg.', 'birž.',
                        'liep.', 'rugp.', 'rugs.', 'spal.', 'lapkr.', 'gruod.'],
                    fullDate: 'y \'m\'. MMMM d \'d\'., EEEE',
                    longDate: 'y \'m\'. MMMM d \'d\'.',
                    medium: 'y-MM-dd HH:mm:ss',
                    mediumDate: 'y-MM-dd',
                    mediumTime: 'HH:mm:ss',
                    short: 'y-MM-dd HH:mm',
                    shortDate: 'y-MM-dd',
                    shortTime: 'HH:mm'
                }
            }
        };
        this.lodash.merge(this.$locale, translations[language]);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/translation/index.js